export default __webpack_public_path__ + "/dist/images/tick.512ee76deeaa61c1e31830f2beacf051.svg";